import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Copy, ExternalLink } from "lucide-react";
import api from "../../api";

// The clinic's own Admin: its patient page and whether the clinic is private
// (training BE organization/booking_link_routes.py, patient_portal.py).
export default function ClinicPageCard() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.getOwnClinicPage().then((r) => setData(r.data)).catch(() => setData(null)); // 403 for non-admins: hidden
  }, []);

  if (!data) return null;

  const toggle = async () => {
    setSaving(true);
    try {
      const r = await api.setOwnClinicPage({ private: !data.private });
      setData(r.data);
      toast.success(r.data.private ? "Your clinic is now private" : "Your doctors are listed on MindConnect again");
    } catch (e) {
      toast.error(e?.response?.data?.error || "Couldn't save.");
    } finally {
      setSaving(false);
    }
  };

  const copy = () => navigator.clipboard?.writeText(data.url)
    .then(() => toast.success("Link copied"), () => toast.error("Couldn't copy the link."));

  return (
    <div className="border border-gray-200 rounded-lg p-4 md:p-5 bg-gray-50 space-y-4">
      <div>
        <h3 className="font-semibold text-gray-800">Clinic page & visibility</h3>
        <p className="text-sm text-gray-500">Your clinic's page lists only your doctors, with your name and logo. Each doctor's booking link shows your clinic first.</p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-primary-700 break-all">{data.url}</span>
        <button type="button" onClick={copy} className="p-1.5 rounded-lg hover:bg-white" title="Copy link"><Copy className="w-4 h-4" /></button>
        <a href={data.url} target="_blank" rel="noopener noreferrer" className="p-1.5 rounded-lg hover:bg-white" title="Open"><ExternalLink className="w-4 h-4" /></a>
      </div>
      <label className="normal-case font-sans tracking-normal flex items-start gap-3 text-sm text-gray-700">
        <input type="checkbox" className="mt-1" checked={data.private} disabled={saving} onChange={toggle} />
        <span>
          <span className="font-medium text-gray-800">Private clinic</span>
          <span className="block text-gray-600">
            Your doctors won't appear in MindConnect's public search, and your pages won't suggest other doctors.
            Patients reach you through your links. A patient who is only with your clinic sees only your clinic after signing in.
          </span>
        </span>
      </label>
    </div>
  );
}
